import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  skuCountTitle: {
    defaultMessage: '2. SKU Count',
    description: 'Title for the SKU count section',
    id: 'CAV8RH',
  },
  skuCountDescription: {
    defaultMessage: 'How many unique product SKUs do you anticipate having fulfilled through our service?',
    description: 'Description for the SKU count section',
    id: 'gQOqDO',
  },
  lessThan50: {
    defaultMessage: 'Less than 50',
    description: 'SKU count option',
    id: 'RGOrOZ',
  },
  fiftyTo100: {
    defaultMessage: '50 - 100',
    description: 'SKU count option',
    id: 'vppkFG',
  },
  oneHundredTo500: {
    defaultMessage: '100 - 500',
    description: 'SKU count option',
    id: 'nlf5zE',
  },
  fiveHundredTo1000: {
    defaultMessage: '500 - 1,000',
    description: 'SKU count option',
    id: 'EN++nX',
  },
  moreThan1000: {
    defaultMessage: 'More than 1,000',
    description: 'SKU count option',
    id: 'pt8vNR',
  },
  unsure: {
    defaultMessage: 'Unsure',
    description: 'SKU count option',
    id: 'OzSWcK',
  },
});
